import { getCheggTldFrom, rewriteCheggTldToMatch, CheggTlds } from '@chegg/utils';

/**
 * Constructs the base Chegg URL based on configuration and user context.
 * @param {Object}      config - config object for getBaseCheggUrl.
 * @param {string}      config.envBaseUrl pass envUrl from config. (e.g. https://www.chegg.com/)
 * @param {boolean}     config.isTldFeaturesEnabled  Enable TLD features flag.
 * @param {CheggRegion} config.targetRegion Optional target region (e.g., 'US', 'MX').
 * @param {string}      config.url User context URL (pass the request url).
 * @returns The constructed base Chegg URL (e.g. https://www.chegg.com.mx when flag is true and url is https://www.chegg.com.mx/path).
 */
export const getBaseCheggUrl = ({
  envBaseUrl,
  isTldFeaturesEnabled,
  targetTld,
  url = '',
}: {
  envBaseUrl: string;
  isTldFeaturesEnabled: boolean;
  targetTld?: string;
  url: string;
}) => {
  // if enviroment is stage, use stage url
  const configUrl = envBaseUrl;

  // TODO remove config killswitch after TLD project stable
  if (isTldFeaturesEnabled) {
    try {
      const newTld = targetTld || getCheggTldFrom(url);
      let rewrittenUrl = rewriteCheggTldToMatch(configUrl, newTld);

      // Remove '.live' from the test environment urls, because test environment subdomains
      // are set up differently than prod.
      if (newTld === CheggTlds.MX) {
        rewrittenUrl = rewrittenUrl?.replace('.live.', '.');
      }
      return rewrittenUrl ?? '';
    } catch (error: unknown) {
      if (error instanceof Error && error.message.startsWith('Invalid URL:')) {
        // If configUrl cannot be parsed to identify the hostname
        // (eg. configUrl is a relative url), then the unaltered
        // configUrl will be returned.
        return configUrl;
      } else {
        throw error;
      }
    }
  }

  return configUrl;
};
